<template>
    <b-modal id="role_delete" ref="role_delete" header-class="no-border" footer-class="no-border"
             @hidden="$emit('close')"
             :title="setTitle">
        You can't revert back your action if you delete this data. For further query, contact Database Manager!

        <template slot="modal-footer">
            <b-button size="sm" variant="secondary" @click="hideModal('role_delete')" v-text="'Cancel'"/>

            <state-button size="sm" v-if="mode === 'role'" variant="danger" :click="deleteRole">Delete</state-button>
        </template>
    </b-modal>
</template>

<script>
import StateButton from "../../../../components/Common/StateButton";

export default {
    name: "RoleDeletemodal",

    components: {
        StateButton
    },

    props: [
        'role', 'mode',
    ],

    computed: {
        setTitle() {
            if (this.mode === 'role') {
                return 'Delete ' + this.role.data.attributes.name + '?';
            } else {
                return 'Delete role?';
            }
        },
    },

    methods: {
        hideModal(refname) {
            this.$refs[refname].hide();
        },

        deleteRole() {
            return new Promise((success, fail) => {
                this.$store.dispatch('deleteRole', this.role)
                    .then(response => {
                        setTimeout(() => {
                            success();

                            this.$emit('deleted-role');

                            this.$notify('error filled', 'Success!', 'Deleted the role!', {
                                duration: 4000,
                                permanent: false
                            });

                            this.hideModal('role_delete');
                        }, 2000);
                    })
                    .catch(error => {
                        setTimeout(() => {
                            fail();
                        }, 1000);
                    });
            })
        },
    }
}
</script>

<style scoped>

</style>
